import React, { useEffect, useState } from 'react'
import Container from '../../components/Container';
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import DataFetching from "../../utils/DataFetching";
import renderDataTable from "../../utils/renderDataTable";
import Breadcrumb from '../../components/Breadcrumb';

const BikesInquiry = () => {
    const location = useLocation();
    const token = useSelector((state) => state.user.userToken)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [filteredData, setFilteredData] = useState([]);
    const [pending, setPending] = useState(true);
    const [resetSearch, setResetSearch] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);

    const fetchData = async () => {
        setPending(true);

        const body = {
            page: currentPage - 1,
            perpage: pageLimit,
        }

        DataFetching(setPending, '/get_bikes_inquiry_details.php', 'POST', token, dispatch, navigate, setFilteredData, setTotalPages, body, setResetSearch, resetSearch);
    };

    // Render the DataTable component
    useEffect(() => {
        if (!resetSearch) {
            return;
        }
        fetchData();
    }, [currentPage, pageLimit, location, resetSearch]);

    const column = [
        {
            name: 'User ID',
            selector: row => row.id,
            width: '7%'
        },
        {
            name: 'Full Name',
            selector: row => row.user_name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: "Phone",
            selector: (row) => row.phone,
            sortable: true,
        },
        {
            name: 'Bike Name',
            selector: row => row.title,
            sortable: true,
        },
        {
            name: 'Message',
            selector: row => row.message,
            sortable: true,
        },
        {
            name: 'Bike Model',
            selector: row => row.model,
            sortable: true,
        },
    ]


    return (
        <>
            <Breadcrumb pageName="Fuel Type" />
            <Container>
                <>
                    <div className="border-2 border-solid border-[#ddddddbe] w-full">
                        <div className='p-3 w-full'>
                            <div className='py-3'>
                                {renderDataTable(
                                    filteredData,
                                    column,
                                    pending,
                                    currentPage,
                                    setPageLimit,
                                    setCurrentPage,
                                    totalPages,
                                    pageLimit,
                                    setResetSearch,
                                    dispatch,
                                    navigate,
                                )}
                            </div>
                        </div>
                    </div>
                </>
            </Container>
        </>
    )
}

export default BikesInquiry;